import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TestWeiyunService {
  newData:any = {}
  rootIp:any;
  serverapi:any="183.6.112.88";
  bgColor:any = "light";
  saveDashboard:any;
  publishDashboard:any;
  
  constructor(private sanitizer:DomSanitizer) { }
  setId(res:any){
    this.newData = res;
  }
    // 创建图形
}

